// extracted by mini-css-extract-plugin
export default {"rowHover":"PubTableRow_rowHover__yVSYT"};